import React, { useState, useEffect } from "react";
import combinedServices from "../../../shared/services/user-service";
import { useNavigate, useLocation } from "react-router-dom";
import Header from "../../../Components/clubDashboard/Header/Header";
import "./productPage.scss";
import POScart from "./POSCart";
import getLocalData from "../../../shared/localStorage/getData";

const POSproductList = () => {
  const [productsData, setProductsData] = useState([]);
  const navigate = useNavigate();
  const location = useLocation();
  const storeId = location.state?.storeId;

  useEffect(() => {
    const fetchProducts = async () => {
      try {
        let productsResponse = await combinedServices.getProductsforUser({storeID:storeId});
        if (productsResponse?.data?.data) {
          setProductsData(productsResponse.data.data || []);
        }
      } catch (error) {
        console.error("Error fetching Products:", error);
      }
    };
    fetchProducts();
  }, []);

  useEffect(() => {

    if (getLocalData("user_info", "isLogin")) {
      var loginUserData = getLocalData("user_info", "all").userData.login_user_detail.data.user;
    }
    const fetchData = async () => {
      try {
        const pos = await combinedServices.userPOSstatus({ userID: loginUserData.id });
        if (pos.data.data.StorePOS) {
          return
        } else {
          navigate(`/club-dashboard`);
        }
      } catch (error) {
        console.error('Error fetching POS status:', error);
      }
    };

    fetchData();

  }, []);

  const handleProductClick = (id) => {
    navigate(`/posproductDetail/${id}`,{ state: { storeId: storeId } });
  };

  const allOrders = (id) => {
    navigate(`/POSOrders`, { state: { storeId: storeId } });
  };

  return (
    <>
      <div className="" >
        <Header />
        <div className="mainCont" >
          <section className="ContactOuter" style={{ paddingTop: '20px', paddingBottom: '40px', marginLeft: '90px' }}>
            <div className="container-fluid">
              <div className="row">
                <div className="col-lg-7" style={{ marginTop: "30px", marginLeft: "60px", marginRight: "60px" }}>
                  <div>
                    <div className="productHd mb-3" style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                      <span style={{ fontSize: "35px", marginTop: "20px" }}>PRODUCTS FOR POS</span>
                      <button onClick={allOrders} className="nambaBtn" style={{ marginLeft: 'auto', marginTop: "25px", marginRight: "15px" }}>
                        All Orders
                      </button>
                    </div>

                    <ul className="d-flex flex-wrap productList p-0" style={{gap: '0px'}}>
                      {productsData.map((product) => {
                        const images = JSON.parse(product.images || "[]");
                        const isOutOfStock = product.totalQuantity === "0";

                        return (
                          <li
                            className="col-6 col-md-4 col-lg-3"
                            key={product.product_id}
                            onClick={() =>
                              !isOutOfStock &&
                              handleProductClick(product.product_id)
                            }
                            style={{
                              cursor: isOutOfStock ? "not-allowed" : "pointer",
                              opacity: isOutOfStock ? 0.4 : 1
                            }}
                          >
                            <div className="inner">
                              <div className="img">
                                <img
                                  src={
                                    images[0] || "https://via.placeholder.com/150"
                                  }
                                  alt={product.product_name || "Product"}
                                />
                              </div>
                              <div
                                className="name mt-3"
                                style={{
                                  color: isOutOfStock ? "red" : "inherit"
                                }}
                              >
                                {product.product_name || "Product Name"}
                                {isOutOfStock && <span> (Out of Stock)</span>}
                                <span className="d-block pt-1">
                                  $
                                  {parseFloat(product.retail_price || 0).toFixed(
                                    2
                                  )}{" "}
                                  USD
                                </span>
                              </div>
                            </div>
                          </li>
                        );
                      })}
                    </ul>
                  </div>
                </div>
                <POScart storeId={storeId}/>
              </div>
            </div>
          </section>
        </div>
      </div>
    </>
  );
};

export default POSproductList;